import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Box, IconButton, Tooltip } from "@mui/material";
import { createMRTColumnHelper } from "material-react-table";
import { Chip } from "@mui/material";
import { toast } from "react-toastify";
import { ContentCopy, RepeatOneSharp } from "@mui/icons-material";
import CustomTable from "../../components/customTable/CustomTable";
import { partnerClient } from "../../app/slices/partnerInvoice/partnerTransactionSlice";

export default function Client({ partnerUsername }) {
  const dispatch = useDispatch();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!partnerUsername) return;

    const fetchClients = async () => {
      setLoading(true);
      try {
        const response = await dispatch(
          partnerClient({ partnerUsername, type: "client" }),
        );
        console.log(response, "client>>>>>>>>>>>");
        if (response.meta.requestStatus === "fulfilled") {
          setClients(response.payload.data || []);
        }
      } catch (error) {
        console.log("error fetching clients: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchClients();
  }, [partnerUsername, dispatch]);

  const sliceResponse =
    clients.length > 0 &&
    clients?.map((item) => ({
      id: item?._id || "-",
      name: item?.name || "-",
      email: item?.Email || "-",
      mobileNo: item?.mobileNo || "-",
      status: item?.status || "-",
      customerRefNo: item?.customerRefNo || "-",
      partnerUsername: item?.partner_username || "-",
      panNumber: item?.PanNumber || "-",
      dob: item?.dob || "-",
      addressLine1: item?.address_line_1 || "-",
      city: item?.city || "-",
      state: item?.state || "-",
      zip: item?.zip || "-",
      sub_partner_id: item?.sub_partner_id?.username || "-",
      bankAccountNo: item?.bank_account_no || "-",
      ifscCode: item?.ifsc_code || "-",
      uniqueId: item?.uniqueId || "-",
      createdAt: item?.createdAt || "-",
      updatedAt: item?.updatedAt || "-",
    }));

  const makeCopyableColumn = (columnHelper, accessorKey, header, size = 30) =>
    columnHelper.accessor(accessorKey, {
      header,
      size,
      Cell: ({ cell }) => {
        const value = cell.row.original[accessorKey];
        const handleCopy = () => {
          navigator.clipboard.writeText(value ?? "");
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={value || "N/A"}>
            <span>
              <IconButton onClick={handleCopy} size="small">
                <ContentCopy fontSize="inherit" />
              </IconButton>
              {value}
            </span>
          </Tooltip>
        );
      },
    });

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("sub_partner_id", {
      header: "Sub Partner",
      size: 30,
    }),
    makeCopyableColumn(columnHelper, "id", "ID"),
    columnHelper.accessor("name", { header: "Name", size: 30 }),
    columnHelper.accessor("email", { header: "Email", size: 30 }),
    columnHelper.accessor("mobileNo", { header: "Mobile No", size: 30 }),
    columnHelper.accessor("status", {
      header: "Status",
      size: 30,
      Cell: ({ cell }) => {
        const status = cell?.row?.original?.status;

        let label = "";
        let color = "";
        let bgColor = "";

        switch (status) {
          case 3:
            label = "KYC Done";
            color = "#2e7d32";
            bgColor = "#e8f5e9";
            break;

          case 2:
            label = "Pending KYC";
            color = "#b26a00";
            bgColor = "#fff3cd";
            break;

          case 1:
            label = "Pending KYC";
            color = "#f57c00";
            bgColor = "#fff8e1";
            break;

          default:
            label = "No KYC";
            color = "#d32f2f";
            bgColor = "#ffebee";
        }

        return (
          <Chip
            label={label}
            size="small"
            sx={{
              backgroundColor: bgColor,
              color: color,
              fontWeight: 600,
              minWidth: 110,
              borderRadius: "16px",
            }}
          />
        );
      },
    }),
    makeCopyableColumn(columnHelper, "customerRefNo", "Customer Ref No"),
    columnHelper.accessor("panNumber", { header: "PAN Number", size: 30 }),
    columnHelper.accessor("dob", { header: "DOB", size: 30 }),
    columnHelper.accessor("uniqueId", { header: "Augmont Id", size: 30 }),
    // columnHelper.accessor("addressLine1", "city", "state", {
    //   header: "Address Line 1",
    //   size: 30,
    // }),

    // columnHelper.accessor("city", { header: "City", size: 30 }),
    // columnHelper.accessor("state", { header: "State", size: 30 }),
    columnHelper.accessor("addressLine1", {
      header: "Address",
      size: 60,
      Cell: ({ row }) => {
        const fullAddress = [
          row.original.addressLine1,
          row.original.city,
          row.original.state,
        ]
          .filter(Boolean)
          .join(", ");

        return <span>{fullAddress || "N/A"}</span>;
      },
    }),
    columnHelper.accessor("zip", { header: "Zip", size: 30 }),
    // columnHelper.accessor("bankAccountNo", { header: "Bank A/C No", size: 30 }),
    // columnHelper.accessor("ifscCode", { header: "IFSC Code", size: 30 }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: ({ cell }) => cell?.row?.original?.createdAt?.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: ({ cell }) => cell?.row?.original?.updatedAt?.split("T")[0],
    }),
  ];

  return (
    <Box mt={2}>
      <CustomTable
        columns={columns}
        data={sliceResponse}
        loading={loading}
        permissionKey="PartnerClient"
      />
    </Box>
  );
}
